import { render, staticRenderFns } from "./pg-table-checkbox.vue?vue&type=template&id=1538f842&scoped=true"
import script from "./pg-table-checkbox.vue?vue&type=script&lang=js"
export * from "./pg-table-checkbox.vue?vue&type=script&lang=js"
import style0 from "./pg-table-checkbox.vue?vue&type=style&index=0&id=1538f842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538f842",
  null
  
)

export default component.exports